import { ClicksignSignature } from '@/features/privateCompanyLeadsFunnel/components/ContractSignatureDetails/ClicksignSignature'
import { ManualSignature } from '@/features/privateCompanyLeadsFunnel/components/ContractSignatureDetails/ManualSignature'
import { PrivateCompanyLeadData } from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLead'

interface ContractSignatureDetailsProps {
  privateCompanyLead: PrivateCompanyLeadData
  disableFields?: boolean
}

export const ContractSignatureDetails = ({ privateCompanyLead, disableFields }: ContractSignatureDetailsProps) => {
  return (
    <>
      {privateCompanyLead?.contract?.signature_type === 'manual' ? (
        <ManualSignature privateCompanyLead={privateCompanyLead} disableFields={disableFields} />
      ) : privateCompanyLead?.contract?.signature_type === 'clicksign' ? (
        <ClicksignSignature privateCompanyLead={privateCompanyLead} disableFields={disableFields} />
      ) : null}
    </>
  )
}
